import { render, staticRenderFns } from "./batchPriceChangeList.vue?vue&type=template&id=487d1859"
import script from "./batchPriceChangeList.vue?vue&type=script&lang=js"
export * from "./batchPriceChangeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports